module.exports = __webpack_public_path__ + "static/images/notfound.1HCTKOD.svg";